import { configureStore, AnyAction } from '@reduxjs/toolkit'
import userReducer from './reducers/userReducer'
import { routerMiddleware } from 'connected-react-router'
import storage from 'redux-persist/lib/storage'
import { persistCombineReducers, persistStore } from 'redux-persist'
import { createBrowserHistory } from 'history'

const persistConfig = {
  key: 'capgains',
  storage,
  blacklist: ['router'],
  timeout: undefined,
}

const logger = () => (next: any) => (action: AnyAction) => {
  console.log('[LOG] Action triggered', action)
  next(action)
}

export const history = createBrowserHistory()

const reducer = persistCombineReducers(persistConfig, {
  user: userReducer,
})

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware({ serializableCheck: false }),
    logger,
    routerMiddleware(history),
  ],
})

export const persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
